import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import { useLocale } from 'locale';
import React from 'react';
import * as Styled from './styled';
import { IOfficeAward, IOfficeAwardCategory, IOfficeAwardYear } from 'utils/entities';
import { Route } from 'config/routes';


const icons = {
  [IOfficeAwardCategory.Top10]: {
    [IOfficeAwardYear.Y2020]: 'madad/award_green_20_20_large.png',
    [IOfficeAwardYear.Y2021]: 'madad/award_green_20_21_large.png',
    [IOfficeAwardYear.Y2022]: 'madad/award_green_21_22_large.png',
    [IOfficeAwardYear.Y2023]: 'madad/award_green_22_23_large.png',
    [IOfficeAwardYear.Y2024]: 'madad/top10-banner-badge-2024.png',
    [IOfficeAwardYear.Y2025]: 'madad/badge-2024-green.png',
    [IOfficeAwardYear.Y2026]: 'madad/badge-2026-green.png',
  },
  [IOfficeAwardCategory.Top10Gold]: {
    [IOfficeAwardYear.Y2020]: 'madad/award_gold_20_20_large.png',
    [IOfficeAwardYear.Y2021]: 'madad/award_gold_20_21_large.png',
    [IOfficeAwardYear.Y2022]: 'madad/award_gold_21_22_large.png',
    [IOfficeAwardYear.Y2023]: 'madad/award_gold_22_23_large.png',
    [IOfficeAwardYear.Y2024]: 'madad/top10gold-banner-badge-2024.png',
    [IOfficeAwardYear.Y2025]: 'madad/badge-2024-gold.png',
    [IOfficeAwardYear.Y2026]: 'madad/badge-2026-gold.png',
  },
};

const getLinkParamsByYear = (year: IOfficeAwardYear) => {
  switch (year) {
    case IOfficeAwardYear.Y2020:
      return { routeName: Route.MadadArchive2020Page };
    case IOfficeAwardYear.Y2021:
    case IOfficeAwardYear.Y2022:
    case IOfficeAwardYear.Y2023:
    case IOfficeAwardYear.Y2024:
    case IOfficeAwardYear.Y2025:
      return { routeName: Route.MadadArchivePage, routeParams: { year: Number(year) } };
    case IOfficeAwardYear.Y2026:
      return { routeName: Route.MadadPage };
  }
};

export const Badge: React.FC<IOfficeAward> = ({ category, year }) => {
  const { t } = useLocale();
  const constructImageURI = useImageUrlBuilder();
  const imageURL = constructImageURI(icons[category][year], { width: 200, height: 200 });

  return (
    <Styled.BadgeWrapper {...getLinkParamsByYear(year)} target="_blank">
      <Styled.Icon year={year}><img src={imageURL} alt={t('awards.subtitle', { year })} /></Styled.Icon>
      <Styled.Content>
        <Styled.Title weight="bold">{t('awards.title')}</Styled.Title>
        <Styled.SubTitle>{t('awards.subtitle', { year })}</Styled.SubTitle>
      </Styled.Content>
    </Styled.BadgeWrapper>
  );
};
